import { useState } from "react";
import { showToast } from "../utils/Toastify";
import { ButtonWrap } from "../tag/CustomTag";
import { Button } from "../tag/Button";
import { TreeMenu } from "./TreeMenu";

export const AdminMenuSettingPopup = ({ selectedParentMenu, onSelectParentMenu, onClose }) => {
    const [selectParentMenu, setSelectParentMenu] = useState(selectedParentMenu);
    const onCheckMenu = () => {
        if (selectParentMenu === null) {
            return showToast.warning("선택된 코드가 없습니다.");
        }

        onSelectParentMenu(selectParentMenu);
        onClose();
    };

    return (
        <>
            <TreeMenu
                selectParentMenu={selectParentMenu}
                onSelectParentMenu={setSelectParentMenu}
                theme={"black"}
            />

            <ButtonWrap>
                <Button
                    onClick={onCheckMenu}
                    className="w-20 h-8 bg-[#0092B8] bg-[#0092B8] rounded text-white font-bold text-sm"
                >
                    선택
                </Button>

                <Button
                    onClick={onClose}
                    className="w-20 h-8 bg-[#F54900] rounded text-white font-bold text-[0.9rem]"
                >
                    닫기
                </Button>
            </ButtonWrap>
        </>
    );
};